import React from 'react'

const CalendarIcon = ({ props }) => (
    <svg
        viewBox="0 0 28 28"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="currentColor"
        {...props}
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <g
                id="🔍-Product-Icons"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g id="ic_fluent_calendar_28_filled" fill="currentColor" fillRule="nonzero">
                    <path
                        d="M25,9.5 L25,21.75 C25,23.5449254 23.5449254,25 21.75,25 L6.25,25 
                        C4.45507456,25 3,23.5449254 3,21.75 L3,9.5 L25,9.5 Z M8.74125236,17.5014095 
                        C8.05089643,17.5014095 7.49125236,18.0610536 7.49125236,18.7514095 
                        C7.49125236,19.4417655 8.05089643,20.0014095 8.74125236,20.0014095 
                        C9.4316083,20.0014095 9.99125236,19.4417655 9.99125236,18.7514095 
                        C9.99125236,18.0610536 9.4316083,17.5014095 8.74125236,17.5014095 
                        Z M13.9957337,17.5014095 C13.3053778,17.5014095 12.7457337,18.0610536 
                        12.7457337,18.7514095 C12.7457337,19.4417655 13.3053778,20.0014095 
                        13.9957337,20.0014095 C14.6860897,20.0014095 15.2457337,19.4417655 
                        15.2457337,18.7514095 C15.2457337,18.0610536 14.6860897,17.5014095 
                        13.9957337,17.5014095 Z M8.74125236,12.5014095 C8.05089643,12.5014095 
                        7.49125236,13.0610536 7.49125236,13.7514095 C7.49125236,14.4417655 
                        8.05089643,15.0014095 8.74125236,15.0014095 C9.4316083,15.0014095 
                        9.99125236,14.4417655 9.99125236,13.7514095 C9.99125236,13.0610536 
                        9.4316083,12.5014095 8.74125236,12.5014095 Z M13.9957337,12.5014095 
                        C13.3053778,12.5014095 12.7457337,13.0610536 12.7457337,13.7514095 
                        C12.7457337,14.4417655 13.3053778,15.0014095 13.9957337,15.0014095 
                        C14.6860897,15.0014095 15.2457337,14.4417655 15.2457337,13.7514095 
                        C15.2457337,13.0610536 14.6860897,12.5014095 13.9957337,12.5014095 
                        Z M19.2502151,12.5014095 C18.5598592,12.5014095 18.0002151,13.0610536 
                        18.0002151,13.7514095 C18.0002151,14.4417655 18.5598592,15.0014095 
                        19.2502151,15.0014095 C19.9405711,15.0014095 20.5002151,14.4417655 
                        20.5002151,13.7514095 C20.5002151,13.0610536 19.9405711,12.5014095 
                        19.2502151,12.5014095 Z M21.75,3 C23.5449254,3 25,4.45507456 
                        25,6.25 L25,8 L3,8 L3,6.25 C3,4.45507456 4.45507456,3 6.25,3 L21.75,3 Z"
                        id="🎨-Color"
                    >
                    </path>
                </g>
            </g>
        </g>
    </svg>
)

export default CalendarIcon